import { useAppDispatch } from 'src/hooks';
import {
  addCommentForCommentDrawerChildItem,
  addCommentForCommentDrawerParentItem,
  deleteCommentForCommentDrawerChildItem,
  deleteCommentForCommentDrawerParentItem,
  updateCommentForCommentDrawerChildItem,
  updateCommentForCommentDrawerParentItem
} from '../../store/planner-slice';
import { IProductComment } from '../../types/ppg-sku-drawer.model';
import useProductComment from '../../hooks/product-comment-hook';

export default function useCommentDrawer() {
  const appDispatch = useAppDispatch();
  const { handleAddComment, handleDeleteComment, handleUpdateComment } =
    useProductComment();

  const handleAddCommentForParentItem = (
    comment: string,
    parentId: number,
    childId: number,
    productIndex: number
  ) =>
    handleAddComment(comment, parentId, childId).then((response) => {
      appDispatch(
        addCommentForCommentDrawerParentItem({
          comment: response.payload as IProductComment,
          productIndex
        })
      );
    });

  const handleDeleteCommentForParentItem = (
    commentId: number,
    productIndex: number
  ) =>
    handleDeleteComment(commentId).then(() => {
      appDispatch(
        deleteCommentForCommentDrawerParentItem({
          commentId,
          productIndex
        })
      );
    });

  const handleUpdateCommentForParentItem = (
    commentId: number,
    updatedComment: string,
    productIndex
  ) =>
    handleUpdateComment(commentId, updatedComment).then((response) => {
      appDispatch(
        updateCommentForCommentDrawerParentItem({
          comment: response.payload as IProductComment,
          productIndex
        })
      );
    });

  const handleAddCommentForChildItem = (
    comment: string,
    parentId: number,
    childId: number,
    parentIndex: number,
    childIndex: number
  ) =>
    handleAddComment(comment, parentId, childId).then((response) => {
      appDispatch(
        addCommentForCommentDrawerChildItem({
          comment: response.payload as IProductComment,
          childIndex,
          parentIndex
        })
      );
    });

  const handleDeleteCommentForChildItem = (
    commentId: number,
    parentIndex: number,
    childIndex: number
  ) =>
    handleDeleteComment(commentId).then(() => {
      appDispatch(
        deleteCommentForCommentDrawerChildItem({
          commentId,
          childIndex,
          parentIndex
        })
      );
    });

  const handleUpdateCommentForChildItem = (
    commentId: number,
    updatedComment: string,
    parentIndex: number,
    childIndex: number
  ) =>
    handleUpdateComment(commentId, updatedComment).then((response) => {
      appDispatch(
        updateCommentForCommentDrawerChildItem({
          comment: response.payload as IProductComment,
          childIndex,
          parentIndex
        })
      );
    });

  return {
    handleAddCommentForParentItem,
    handleAddCommentForChildItem,
    handleUpdateCommentForParentItem,
    handleUpdateCommentForChildItem,
    handleDeleteCommentForParentItem,
    handleDeleteCommentForChildItem
  };
}
